import { useContext } from 'react';
import { DemoContext, type DemoContextValue } from './demoContext';

export function useDemo(): DemoContextValue {
  const ctx = useContext(DemoContext);
  if (!ctx) throw new Error('useDemo must be used inside a DemoProvider');
  return ctx;
}
